import { FIBER_POP_BULK_REVIEW } from '../../../common/constants/constants';
import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';

export const reviewBulkFiberPopUpload = async (payload) => {
  try {
    const response = await apiClient.post(FIBER_POP_BULK_REVIEW, payload);
    return response.data;
  } catch (error) {
    handleApiError(error);
  }
};
